import http from '@/plugins/axios/axios';

export default class RelogioPontoService {

    salvar(requisicao) {       
        return http.post('/api/relogio-ponto/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/relogio-ponto/excluir', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/relogio-ponto/listar', requisicao);
    }

    buscarToken(requisicao) {       
        return http.post('/api/relogio-ponto/buscar-token', requisicao);
    }

    gerarToken(requisicao) {       
        return http.post('/api/relogio-ponto/gerar-token', requisicao);
    }

    tokenGerado(requisicao) {       
        return http.post('/api/relogio-ponto/token-gerado', requisicao);
    }

    atualizarNSR(requisicao) {       
        return http.post('/api/relogio-ponto/atualizar-nsr', requisicao);
    }

    ativarMonitoramento(requisicao) {       
        return http.post('/api/relogio-ponto/ativar-monitoramento', requisicao);
    }

    desativarMonitoramento(requisicao) {       
        return http.post('/api/relogio-ponto/desativar-monitoramento', requisicao);
    }

    criarTarefaSincronismoTodos(requisicao) {
        return http.post('/api/relogio-ponto/criar-tarefa-sincrionizar-todos', requisicao);
    }

    criarTarefaSincronismoSelecionados(requisicao) {
        return http.post('/api/relogio-ponto/criar-tarefa-sincrionizar-selecionados', requisicao);
    }

    criarTarefaImportarImagens(requisicao) {
        return http.post('/api/relogio-ponto/criar-tarefa-importar-imagens', requisicao);
    }

    listarMonitoramentoPushPorCnpj(idCnpj) {       
        return http.get('/api/relogio-ponto/monitoramento/listar?idCnpj=' + idCnpj);
    }

    buscarRepMonitoramento(id) {       
        return http.get('/api/relogio-ponto/monitoramento/buscar/' + id);
    }

    listarTarefasComServicoPushAsync(idCnpj) {       
        return http.get(`/api/tarefas-relogio-ponto/push-async?idCnpj=${idCnpj}`);
    }

    excluirTarefas(idCnpj) {       
        return http.delete(`/api/tarefas-relogio-ponto/excluir/cnpj/${idCnpj}`);
    }
}